import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="aep-swift" api="clear-queue" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func clearQueue()
`}</code></pre>
    <Variant platform="aep-objc" api="clear-queue" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) clearQueue;
`}</code></pre>
    <Variant platform="acp-objc" api="clear-queue" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) clearQueue;
`}</code></pre>
    <Variant platform="aep-swift" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static var extensionVersion: String
`}</code></pre>
    <Variant platform="aep-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="acp-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="aep-swift" api="get-queue-size" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getQueueSize(completion: @escaping (Int, Error?) -> Void)
`}</code></pre>
    <Variant platform="aep-objc" api="get-queue-size" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getQueueSize:^(NSInteger queueSize, NSError * _Nullable error)completion;
`}</code></pre>
    <Variant platform="acp-objc" api="get-queue-size" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getQueueSize: (nonnull void (^) (NSUInteger queueSize)) callback;

+ (void) getQueueSizeWithCompletionHandler: (nonnull void (^) (NSUInteger queueSize, NSError* __nullable error)) completionHandler;
`}</code></pre>
    <Variant platform="aep-swift" api="get-tracking-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getTrackingIdentifier(completion: @escaping (String?, Error?) -> Void)
`}</code></pre>
    <Variant platform="aep-objc" api="get-tracking-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getTrackingIdentifier:^(NSString * _Nullable trackingIdentifier, NSError * _Nullable error)completion;
`}</code></pre>
    <Variant platform="acp-objc" api="get-tracking-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getTrackingIdentifier: (nonnull void (^) (NSString* __nullable trackingIdentifier)) callback;

+ (void) getTrackingIdentifierWithCompletionHandler: (nonnull void (^) (NSString* __nullable trackingIdentifier, NSError* __nullable error)) completionHandler;
`}</code></pre>
    <Variant platform="aep-swift" api="get-visitor-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getVisitorIdentifier(completion: @escaping (String?, Error?) -> Void)
`}</code></pre>
    <Variant platform="aep-objc" api="get-visitor-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getVisitorIdentifier:^(NSString * _Nullable visitorIdentifier, NSError * _Nullable error)completion;
`}</code></pre>
    <Variant platform="acp-objc" api="get-visitor-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getVisitorIdentifier: (nonnull void (^) (NSString* __nullable visitorIdentifier)) callback;

+ (void) getVisitorIdentifierWithCompletionHandler: (nonnull void (^) (NSString* __nullable visitorIdentifier, NSError* __nullable error)) completionHandler;
`}</code></pre>
    <Variant platform="aep-swift" api="send-queued-hits" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func sendQueuedHits()
`}</code></pre>
    <Variant platform="aep-objc" api="send-queued-hits" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) sendQueuedHits;
`}</code></pre>
    <Variant platform="acp-objc" api="send-queued-hits" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) sendQueuedHits;
`}</code></pre>
    <Variant platform="aep-swift" api="set-visitor-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func setVisitorIdentifier(visitorIdentifier: String)
`}</code></pre>
    <Variant platform="aep-objc" api="set-visitor-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) setVisitorIdentifier:(NSString * _Nonnull) visitorIdentifier;
`}</code></pre>
    <Variant platform="acp-objc" api="set-visitor-identifier" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) setVisitorIdentifier: (nonnull NSString*) visitorIdentifier;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      